import { rejected, resolved } from 'store/createAction';
import { CREATE_USER, DELETE_USER, GET_USERS, UPDATE_USER } from '../types';

const initialState = {
  loading: false,
  data: [],
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_USERS:
      return {
        ...state,
        loading: true,
      };

    case resolved(GET_USERS): {
      return {
        ...state,
        loading: false,
        data: payload,
      };
    }
    default:
      return state;
  }
};
